<template>
  <div class="select">
    <select v-model="value" @change="$emit('update', value)">
      <option>0</option>
      <option>1</option>
      <option>2</option>
      <option>3</option>
      <option>4</option>
      <option>5</option>
      <option>6</option>
      <option>7</option>
      <option>8</option>
      <option>9</option>
    </select>
  </div>
</template>

<script>
export default {
  props: { content: String },
  data() {
    return {
      value: this.content
    };
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=ZCOOL+QingKe+HuangYou&display=swap");
.select select {
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: "";
  font-size: 30px;
  background: none;
  border: none;
  font-family: "ZCOOL QingKe HuangYou", cursive;
  color: rgb(230, 230, 230);
  font-weight: bold;
  width: 300%;
}
select:focus {
  outline: none;
}
select:hover {
  cursor: pointer;
}
</style>
